interface DonationCopy {
  header: string;
  subHeader: string;
}

export const useCharityCopy = (eventType: string): DonationCopy => {
  switch (eventType) {
    case 'birthday_forkids':
      return {
        header: 'Support Your School or Charity',
        subHeader: "Invite guests to donate to your favorite charity or child's school",
      };

    case 'birthday_forteens':
      return {
        header: 'Support Your School or Charity',
        subHeader: "Invite guests to donate to your favorite charity or child's school",
      };

    case 'birthday_milestones':
      return {
        header: 'Support a Cause You Care About',
        subHeader: 'Choose from 100s of certified nonprofits.',
      };

    case 'bridal_shower':
      return {
        header: 'Support a Cause You Care About',
        subHeader: 'Choose from 100s of certified nonprofits.',
      };

    case 'brunch_lunch':
      return {
        header: 'Support a Cause You Care About',
        subHeader: 'Choose from 100s of certified nonprofits.',
      };

    case 'christmas':
      return {
        header: 'Give in the Spirit of the Season',
        subHeader: 'Choose from 100s of certified nonprofits.',
      };

    case 'holiday_party':
      return {
        header: 'Give in the Spirit of the Season',
        subHeader: 'Choose from 100s of certified nonprofits.',
      };

    case 'graduation':
      return {
        header: 'Support Your School or Charity',
        subHeader: "Invite guests to donate to your favorite charity or child's school",
      };

    case 'thanksgiving':
      return {
        header: 'Support Your Favorite Charity',
        subHeader: 'Give thanks by inviting guests to donate a charity of your choice',
      };

    case 'valentines_day':
      return {
        header: 'Spread Love by Giving Back',
        subHeader: 'Choose from 100s of certified nonprofits.',
      };

    case 'charity_fundraisers':
      return {
        header: 'Add Charity',
        subHeader: 'Select your charity for direct donations through Evite',
      };

    case 'funeral_memorial_service':
      return {
        header: 'Add a charity in memory of your loved one',
        subHeader: 'Invite guests to donate to a cause in honor of your loved one.',
      };

    default:
      return {
        header: 'Support a Cause You Care About',
        subHeader: 'Choose from 100s of certified nonprofits.',
      };
  }
};

export const useCrowdfundCopy = (eventType: string): DonationCopy => {
  switch (eventType) {
    case 'baby_shower':
      return {
        header: 'Create a Baby Fund',
        subHeader: 'Invite guests to give to the expecting parents',
      };

    case 'babys_first':
      return {
        header: 'Create a Baby Fund',
        subHeader: 'Invite guests to give to the expecting parents',
      };

    case 'bridal_shower':
      return {
        header: 'Add a Honeymoon or Wedding Fund',
        subHeader: 'Invite guests to provide funds for an upcoming honeymoon or big purchase',
      };

    case 'graduation':
      return {
        header: 'Add a Graduation or College Fund',
        subHeader: 'Invite guests to support the graduate in their next steps',
      };

    case 'retirement_farewell':
      return {
        header: 'Create a Retirement Fund',
        subHeader: 'Invite guests to raise funds for you or on behalf of someone else',
      };

    case 'charity_fundraiser':
      return {
        header: 'Personal Fundraising',
        subHeader:
          "Don't see the charity you prefer? Create a personal fundraiser to gather donations with Evite",
      };

    case 'funeral_memorial_service':
      return {
        header: 'Support the family of the deceased',
        subHeader: "Add a crowdfund to fundraise for the loved one's family or funeral",
      };

    case 'weddings':
      return {
        header: 'Add a Honeymoon or Down Payment Fund',
        subHeader: 'Invite guests to provide funds for an upcoming honeymoon or big purchase',
      };

    default:
      return {
        header: 'Crowdfunding',
        subHeader: 'Allow guests to contribute to a personal cause or savings fund.',
      };
  }
};
